import { Link } from 'react-router-dom';
import calenderTick from './../../../../../src/assets/img/calender-tick.png';
import { ROUTE_PATHS, TARGET_BLANK } from 'utils/constants/routes';
import { IBTTabRow, IScheduleLineItem } from 'model/v2';

const formatOpensOnDate = (dateStr: string): string => {
  const date = new Date(dateStr + 'T00:00:00');
  const formatted = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return `Week of ${formatted}`;
};

const RemainingScheduleCell = ({ items }: { items: IScheduleLineItem[] }) => {
  if (items.length === 0) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={calenderTick} alt="calenderTick" width={20} />
        <span style={{ marginLeft: 4, marginTop: 4 }}>Booked !</span>
      </div>
    );
  }
  return (
    <div>
      {items.map((item, idx) => {
        const lines = item.text.split('\n');
        const opensLabel = item.opensOn ? ` [Opens: ${formatOpensOnDate(item.opensOn)}]` : '';
        return (
          <div key={idx} style={{ marginBottom: idx < items.length - 1 ? 4 : 0 }}>
            <div>{lines[0]}{opensLabel}</div>
            {lines.slice(1).map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export const useBTTabColumns = () => {
  const columns = [
    {
      title: 'BT',
      dataIndex: 'bt',
      key: 'bt',
      render: (text: string, row: IBTTabRow) => {
        const providerProfileUrl = `${ROUTE_PATHS.PROVIDER}${row.btId}`;
        return (
          <Link
            to={providerProfileUrl}
            target={TARGET_BLANK}
            style={{
              textDecoration: 'none',
              color: '#6f42f5',
              cursor: 'pointer'
            }}
          >
            {text}
          </Link>
        );
      }
    },
    { title: 'Clinic', dataIndex: 'clinic', key: 'clinic' },
    {
      title: 'Set Shift',
      dataIndex: 'setShift',
      key: 'setShift',
      render: (text: string[]) => {
        return text.length > 0 ? (
          text.map((line: string) => {
            return line
              .split('\n')
              .map((line: string, i: number) => <div key={i}>{line}</div>);
          })
        ) : (
          <div>None</div>
        );
      }
    },
    {
      title: 'Remaining Set Shift Hours',
      dataIndex: 'remainingSetShift',
      key: 'remainingSetShift',
      render: (items: IScheduleLineItem[], record: IBTTabRow) => {
        if (record.setShift.length === 0) {
          return <div>None</div>;
        }
        return <RemainingScheduleCell items={items} />;
      }
    },
    {
      title: 'Additional Hours',
      dataIndex: 'additionalHours',
      key: 'additionalHours',
      render: (text: string[]) => {
        return text.length > 0 ? (
          text.map((line: string) => {
            return line
              .split('\n')
              .map((line: string, i: number) => <div key={i}>{line}</div>);
          })
        ) : (
          <div>None</div>
        );
      }
    },
    {
      title: 'Remaining Additional Hours',
      dataIndex: 'remainingAdditional',
      key: 'remainingAdditional',
      render: (items: IScheduleLineItem[], record: IBTTabRow) => {
        if (record.additionalHours.length === 0) {
          return <div>None</div>;
        }
        return <RemainingScheduleCell items={items} />;
      }
    }
  ];

  return {
    columns
  };
};
